import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=fb19114c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=fb19114c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb19114c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb19114c')) {
      api.createRecord('fb19114c', component.options)
    } else {
      api.reload('fb19114c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=fb19114c&scoped=true&", function () {
      api.rerender('fb19114c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eN0PTEkeyodf/JS/comp/GuestBox.vue"
export default component.exports